<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  document.querySelectorAll('a').forEach(link => {
  link.addEventListener('mouseover', function() {
    this.dataset.title = this.getAttribute('title'); // Store the title in a data attribute
    this.removeAttribute('title'); // Remove the title attribute to hide tooltip
  });
  link.addEventListener('mouseout', function() {
    this.setAttribute('title', this.dataset.title); // Restore the title attribute
  });
});

/* ============================================================================
   Setosa site-wide enhancements (readability-safe, progressive enhancement)
   ============================================================================ */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  ready(function () {
    /* ---- Scroll progress bar ---- */
    try {
      var bar = document.createElement('div');
      bar.id = 'setosa-progress';
      document.body.appendChild(bar);
      var onScroll = function () {
        var h = document.documentElement;
        var max = (h.scrollHeight - h.clientHeight) || 1;
        bar.style.width = (Math.min(1, h.scrollTop / max) * 100) + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    } catch (e) {}

    if (REDUCE) return;

    /* ---- Scroll reveal for product & collection pages (homepage uses GSAP) ---- */
    try {
      var targets = [];
      document.querySelectorAll(
        '.sp .sp-section, .sp .sp-card, .sp .sp-gallery, .sc .sc-hero, .sc .sc-trust, .sc .sc-card'
      ).forEach(function (el) { targets.push(el); });

      if (targets.length && 'IntersectionObserver' in window) {
        targets.forEach(function (el, i) {
          el.classList.add('setosa-reveal');
          el.style.transitionDelay = ((i % 6) * 0.05) + 's';
        });
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
          });
        }, { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
        targets.forEach(function (el) { io.observe(el); });
      }
    } catch (e) {}

    /* ---- Magnetic primary buttons (desktop pointers only) ---- */
    try {
      var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
      if (fine) {
        document.querySelectorAll('.setosa-gradient-btn, .sh-btn, .sp-add, .sc-card__cta, .sp-sticky__btn')
        .forEach(function (btn) {
          btn.style.willChange = 'transform';
          btn.addEventListener('mousemove', function (e) {
            var r = btn.getBoundingClientRect();
            var mx = e.clientX - r.left - r.width / 2;
            var my = e.clientY - r.top - r.height / 2;
            btn.style.transform = 'translate(' + (mx * 0.12) + 'px,' + (my * 0.18) + 'px)';
          });
          btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
        });
      }
    } catch (e) {}
  });
})();

/* ============================================================================
   Setosa PDP enhancements v3 — 3D tilt + prominent free-gift progress bar
   ============================================================================ */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  function moneyPKR(minor) { return 'Rs. ' + Math.ceil(minor / 100).toLocaleString('en-PK'); }

  ready(function () {
    /* ---- FREE-GIFT promo banner (static — gift given on any order above Rs. 5,000) ---- */
    try {
      var host = document.querySelector('.halo-productView-right')
              || document.querySelector('.sp-info')
              || document.querySelector('.cart__items, .cart-items, form[action="/cart"], .cart__footer');
      if (host && !document.getElementById('setosa-gift')) {
        var box = document.createElement('div');
        box.id = 'setosa-gift';
        box.className = 'setosa-glass-strong is-static';
        box.innerHTML = '<div class="sg-top"><span class="sg-ico">🎁</span>'
          + '<span class="sg-msg"><strong>Get Free Toner or Cleanser on Orders Above 5k+</strong></span></div>';
        host.insertBefore(box, host.firstChild);
        var top = box.querySelector('.sg-top'); if (top) top.style.marginBottom = '0';
      }
    } catch (e) {}

    if (REDUCE || !FINE) return;

    /* ---- 3D tilt on the product image + feature cards ---- */
    try {
      var tiltEls = document.querySelectorAll(
        '.halo-productView-left .productView-image, .sp-main, .sh-why__card, .sp-card'
      );
      tiltEls.forEach(function (el) {
        var max = el.classList.contains('productView-image') || el.classList.contains('sp-main') ? 7 : 5;
        el.addEventListener('mousemove', function (e) {
          var r = el.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          el.style.transform = 'perspective(1000px) rotateY(' + (px * max) + 'deg) rotateX(' + (-py * max) + 'deg) scale(1.02)';
        });
        el.addEventListener('mouseleave', function () { el.style.transform = ''; });
      });
    } catch (e) {}
  });
})();
